import type { RouteRecordRaw } from 'vue-router'

const productRoutes: RouteRecordRaw[] = [
  {
    path: 'products',
    component: () => import('@/views/product/ProductMgmtLayout.vue'),
    redirect: '/products/overview',
    children: [
      {
        path: 'overview',
        name: 'product-mgmt-overview',
        component: () => import('@/views/product/Productlist.vue'),
        meta: { title: '产品资产总览' }
      },
      {
        path: 'work-pool',
        name: 'product-mgmt-work-pool',
        component: () => import('@/views/product/WorkPool.vue'),
        meta: { title: '岗位梳理 / 工作池' }
      },
      {
        path: 'selection',
        name: 'product-mgmt-selection',
        component: () => import('@/views/product/Selection.vue'),
        meta: { title: '产品选定 / 岗位匹配' }
      },
      {
        path: 'blueprint',
        name: 'product-mgmt-blueprint',
        component: () => import('@/views/product/Blueprint.vue'),
        meta: { title: '建设蓝图' }
      },
      {
        path: 'maturity',
        name: 'product-mgmt-maturity',
        component: () => import('@/views/product/MaturityStats.vue'),
        meta: { title: '成熟度统计' }
      }
    ]
  }
]

export default productRoutes
